import status from "../constants/actionStatus";

const initialState = {
    data: [],
    status: status.PENDING
};

export default (state = initialState, action = {}) => {
    if (action.type === 'GET_ALL_TEST_SUCCESS') {
        return {
            data: action.payload,
            status: status.SUCCESS,
            examId: action.examId,
            lastUpdated: action.lastUpdated
        };
    } else if (action.type === 'GET_ALL_TEST_PENDING' || action.type === 'USER_LANGUAGE_UPDATED') {
        return initialState;
    } else if (action.type === 'GET_ALL_UPDATED_TEST') {
        let olderQuizzes = state.data;
        let updatedQuizzes = action.payload;
        let newQuizData = [ ...updatedQuizzes ];
        if (olderQuizzes && olderQuizzes.length) {
            olderQuizzes.forEach((item) => {
                const isDuplicateItem = newQuizData.some(data => data._id === item._id);
                if (!isDuplicateItem) {
                    newQuizData.push(item);
                }
            });
        }
        return {
            data: newQuizData,
            status: status.SUCCESS,
            examId: action.examId,
            lastUpdated: action.lastUpdated
        };
    } else if (action.type === 'TOGGLE_QUIZ__SAVED_SUCCESS') {
        //change state of question from list of questions being shown on screen.
        let quizzes = state.data;
        let quizList = quizzes.map((quiz)=>{
            quiz = { ...quiz };// copy
            if (quiz._id !== action.payload.quizId) {
                return quiz;
            } else {
                //toggle status.
                quiz.isSaved = !quiz.isSaved;
                return quiz;
            }
        });
        quizList = [ ...quizList ];
        return {
            status: status.SUCCESS,
            data: quizList
        };
    }
    return state;
};
